
export class RedeModel {
    constructor(
        public id: string = '',
        public nome: string = '',
    ) {}
}